<template>
  <div class="">
    <!-- 子页面banner -->
    <div class="x-banner">
      <BANNER></BANNER>
      <NAVIGATION
        :data="navigationData"
        :currentPath="currentPath"
      ></NAVIGATION>
    </div>
    <!-- 医院简介 -->
    <div class="container-width yygk-block">
      <div class="title">百年沧桑巨变 使命铸就辉煌</div>
      <div class="y-nr">
        <div class="n1">
          <img src="@/assets/image/yy.png" />
        </div>
        <div class="n2">
          <div class="multi-ellipsis8" v-html="current.description"></div>
        </div>
      </div>
    </div>
    <!-- 滚动数据 -->
    <SCROLLViEW :Data="yygkData"></SCROLLViEW>
  </div>
</template>
<script>
import service from "../../service/yygk";
import BANNER from "../../components/banner/yygk";
import SCROLLViEW from "@/components/yygk/scrollview";
export default {
  name: "YYGKINDEX",
  data() {
    return {
      navigationData: [
        {
          name: "医院概况",
          path: "/yygk/home",
        },
      ],
      currentPath: "/yygk/home",
      yygkData: [],
      current: {},
    };
  },
  components: {
    BANNER,
    SCROLLViEW,
  },
  computed: {},
  created() {
    this.init();
  },
  beforeMount() {},
  methods: {
    init() {
      let parmes = {
        pageIndex: 1,
        pageSize: 50,
        isshow: 1,
      };
      service.getDescFirst(parmes, (res) => {
        this.current = { ...res.content[0] };
      });
      service.getDescList(parmes, (res) => {
        if (res.content.length) {
          res.content.map((item) => {
            if (item.introduction) {
              item.introduction =
                item.introduction.length > 40
                  ? item.introduction.substring(0, 40) + "..."
                  : item.introduction;
            }
          });
        }
        this.yygkData = res.content;
      });
    },

    // swiperiImg() {
    //   var wW = $(window).width();
    //   var swipericon;
    //   if (wW > 768) {
    //     swipericon = new Swiper(".honor_swiper", {
    //       slidesPerView: 4,
    //       mode: "horizontal",
    //       speed: 3000,
    //       autoplay: {
    //         // stopOnLastSlide: false,
    //         // disableOnInteraction: true, // 鼠标移入立即暂停所有动画
    //         // delay: 0, //1秒切换一次
    //         delay: 1000,
    //         disableOnInteraction: true,
    //       },

    //       loop: true,
    //       navigation: {
    //         nextEl: ".fr",
    //         prevEl: ".fl",
    //       },
    //     });
    //   } else {
    //     swipericon = new Swiper(".honor_swiper", {
    //       slidesPerView: "2",
    //       mode: "horizontal",
    //     });
    //   }
    //   //鼠标覆盖停止自动切换
    //   swipericon.el.onmouseover = function () {
    //     swipericon.autoplay.stop();
    //   };

    //   //鼠标离开开始自动切换
    //   swipericon.el.onmouseout = function () {
    //     swipericon.autoplay.start();
    //   };
    // },
  },
  mounted() {},
  watch: {},
};
</script>


<style scoped lang="scss">
/* 医院概况 */
.yygk-block {
  .title {
    font-size: 1.6rem;
    font-weight: bold;
    text-align: center;
    margin-top: 50px;
  }
  .y-nr {
    display: flex;
    flex-direction: row;
    justify-items: flex-end;
    flex-direction: row-reverse;
    margin-top: 50px;
    .n1 {
      width: 50%;
      img {
        width: 90%;
        margin-left: 5%;
      }
    }
    .n2 {
      width: 50%;
      box-shadow: 0 2px 20px rgba(0, 0, 0, 0.12);
      padding: 10px;
      box-sizing: border-box;
    }
  }
}

/* 小屏幕（平板，大于等于 420px） */
@media only screen and (max-width: 768px) {
  .yygk-block {
    .title {
      font-size: 1.4rem;
      margin-top: 20px;
    }
    .y-nr {
      flex-direction: column;
      margin-top: 20px;
      .n1 {
        width: 92%;
        margin-left: 4%;
        img {
          width: 100%;
          margin-left: 0;
        }
      }
      .n2 {
        width: 92%;
        margin-left: 4%;
        margin-top: 20px;
      }
    }
  }
}

/* 小屏幕（平板，大于等于 420px） */

@media only screen and (min-width: 421px) and (max-width: 767px) {
}

/* 小屏幕（平板，大于等于 768px） */
@media only screen and (min-width: 768px) {
}

/* 中等屏幕（桌面显示器，大于等于 992px） */
@media only screen and (min-width: 992px) {
}

/* 大屏幕（大桌面显示器，大于等于 1200px） */
@media only screen and (min-width: 1200px) {
}

/* 小屏幕（平板，大于等于 768px） */
@media only screen and (min-width: 1330px) {
}
</style>
